export const MODERNIZED_SEGMENTATION_PREVIEW_KEY = 'modernizedSegmentation';
